import { render, staticRenderFns } from "./ClassPolicyForm.vue?vue&type=template&id=6fafa6a2"
import script from "./ClassPolicyForm.vue?vue&type=script&lang=js"
export * from "./ClassPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports